import { QuizEditorUrls } from '../shared/utils/urlBuilders/QuizEditorUrlBuilder';
import axios from './localAxios';

const quizEditorUrls = new QuizEditorUrls();

const createPayload = (quizStandard) => {
  const {
    subject,
    core,
    standard: { id, name, short_description },
  } = quizStandard;
  const standardPayload = {
    subject_id: subject,
    core_id: core,
    grade_id: quizStandard['class'],
    standard_id: id,
    name: name,
    description: short_description,
  };
  return standardPayload;
};

const createStandard = async ({
  quizId,
  standard,
}: {
  quizId: number;
  standard;
}) => {
  const url = quizEditorUrls.createStandardsUrl(quizId);
  const payload = createPayload(standard);
  const response = await axios.post(url, payload);
  return response;
};

const updateStandard = async ({
  quizId,
  standardId,
  standard,
}: {
  quizId: number;
  standardId: number | null;
  standard;
}) => {
  const url = quizEditorUrls.updateOrDeleteStandardsUrl(quizId, standardId);
  const payload = createPayload(standard);
  const response = axios.put(url, payload);
  return response;
};

const deleteStandard = async ({
  quizId,
  standardId,
}: {
  quizId: number;
  standardId: number;
}) => {
  const url = quizEditorUrls.updateOrDeleteStandardsUrl(quizId, standardId);
  const response = await axios.delete(url);
  return response;
};

export { createStandard, updateStandard, deleteStandard };
